
export default {
  name: 'SharingOptionPill',
  props: {
    optionKey: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
};
